import React from 'react';
import type { LoaderFunction, RouteObject } from 'react-router-dom';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { Home } from '../../pages/home/page';
import { SingleCategory } from '../../pages/singleCategory/page';
import { ErrorFallback } from '../error/ErrorFallback';

export type AppRoutes = '/' | `/${string}`;

const createRoute = (
  path: AppRoutes,
  element: React.ReactNode,
  loader?: LoaderFunction
): RouteObject => ({
  path,
  element,
  loader,
  errorElement: <ErrorFallback />,
});

const router = createBrowserRouter([
  createRoute('/', <Home />),
  createRoute('/:id', <SingleCategory />, async ({ params }) => params.id),
]);

export const AppRouter = () => <RouterProvider router={router} />;
